const baskaran = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Eee/faculties/teachingfac/1-Baskaran-_3_.webp"
const cover = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Eee/eee-cover.webp"
const asr = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Ece/faculties/teachingfac/ASR.webp"
const Ramanathan = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Faculties/Teaching_fac/1.Dr.K.Ramanathan+Prof+%26+Head.webp"
const kavitha = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Civil/Faculties/Teaching_fac/Civil+S.M.Kavitha-1.webp"
const dpm = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/boy.webp"
const dpf = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Default_profile+/girl.webp"
const Padmanaban = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Eee/faculties/teachingfac/12+Padmanaban+(1).webp"
const img1 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_1.webp"
const img2 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_2.webp"
const img3 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_3.webp"
const img4 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_4.webp"
const img5 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_5.webp"
const img6 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/MAIN_BUILDING_WEBSITE.webp"
const ezhilarasi = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/ezhilarasi.webp"
const shankar = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/shanker.webp"
const PA = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/PA+Photo.webp"


const board_members = [
  // {
  //   id: "1",
  //   cover: cover,
  //   dp: baskaran,
  //   name: "Dr.K.Baskaran",
  //   Designation2: "Principal and HOD (EEE)",
  //   Designation: "Director - AIF",
  //   mailid: "drbaskaran@accetedu.in",
  // },
  {
    id: "2",
    cover: cover,
    dp: asr,
    name: "Dr.A.Sivanantha Raja",
    Designation2: "Head of the department - ECE",
    Designation: "Director - AIF",
    mailid: "sivanantharaja@accet.ac.in",
  },
  {
    id: "3",
    cover: cover,
    dp: Ramanathan,
    name: "Dr.K.Ramanathan",
    Designation2: "Head of the department - MECH",
    Designation: "Director - AIF",
    mailid: "ramsananthi@gmail.com",
  },
  {
    id: "4",
    cover: cover,
    dp: kavitha,
    name: "Dr.S.M.Kavitha",
    Designation2: "Associate Professor - CIVIL",
    Designation: "Director - AIF",
    mailid: "smkavitha@accetedu.in",
  },
  {
    id: "5",
    cover: cover,
    dp: PA,
    name: "Mr. B. Saravanan",
    Designation2: "Personal Assistant to Principal",
    Designation: "Director - AIF",
    mailid: "",
  },
];
const core_team = [
  {
    id: "1",
    cover: cover,
    dp: kavitha,
    name: "Dr.S.M.Kavitha",
    Designation: "Coordinator",
    Designation2: "Alagappa Incubation Forum",
    mailid: "smkavitha@accetedu.in",
  },
  {
    id: "2",
    cover: cover,
    dp: Padmanaban,
    name: "Dr.K.Padmanaban",
    Designation: "Co-Coordinator",
    Designation2: "Alagappa Incubation Forum",
    mailid: "padmanaban.acgcet@gmail.com",
  },
  {
    id: "3",
    cover: cover,
    dp: shankar,
    name: "Mr.M.Shankar Ganesh ",
    Designation: "Incubation Manager",
    Designation2: "Alagappa Incubation Forum",
    mailid: "shankarganesh1993@gmail.com",
  },
  {
    id: "4",
    cover: cover,
    dp: ezhilarasi,
    name: "Mrs.K.Ezhilarasi",
    Designation: "Incubation Associate",
    Designation2: "Alagappa Incubation Forum",
    mailid: "cholanezhilarasi@gmail.com",
  },
];
const incubation_vision = {
  id: "1",
  visiondata:
    "AIF has been created with the vision to foster a culture of innovation and entrepreneurship within the academic community and across the region it serves.",
};
const incubation_mission = [

  {
    id: "1",
    mission:
      "Promote entrepreneurship and startup culture – Provide mentorship, resources, and incubation facilities to help innovators transform ideas into sustainable and successful ventures.",
  },
  {
    id: "2",
    mission:
      "Foster innovation and creativity within academia – Encourage students, faculty, and researchers to generate novel ideas and develop impactful solutions through innovation and research.",
  },
  {
    id: "3",
    mission:
      "Extend impact to the surrounding region and community – Serve as a hub that connects academia, industry, and society, driving employment, economic growth, and social development.",
  },

];

const incubation_objectives = [
  {
    id: "1",
    point:
      "Establish AIF as the Technical Hub of Sivaganga District by offering advanced facilities, expert guidance, and innovation-driven initiatives.",
  },
  {
    id: "2",
    point:
      "Support idea-to-enterprise transformation by providing access to host institute laboratories, mentoring, and fully equipped working spaces.",
  },
  {
    id: "3",
    point:
      "Build a strong talent pool across Sivaganga District through workshops, hackathons, and entrepreneurial events that nurture creativity and skills.",
  },
  {
    id: "4",
    point:
      "Attract startups to AIF by showcasing the talent pool of our students and the strong laboratory infrastructure of our institution.",
  },
];

const incubation_menu = [
  {
    id: "1",
    path: "/incubation",
    link: "About",
    arl: "l",
  },
  {
    id: "2",
    path: "/incubation/startup_support_services",
    link: "Startup Support Services",
    arl: "l",
  },
  {
    id: "3",
    path: "/incubation/focus_sector",
    link: "Focus Sectors & Mentors",
    arl: "l",
  },
  // {
  //     id: "4",
  //     path: "/incubation",
  //     link: "AIF R & D Laboratory",
  //     arl: "l",
  // },

  {
    id: "6",
    path: "/incubation/board_members",
    link: "Board Members",
    arl: "l",
  },

  // {
  //     id: "6",
  //     path: "/incubation/faculty_mentors",
  //     link: "Faculty Mentors ",
  //     arl: "l",
  // },
  {
    id: "6",
    path: "/incubation/incubation_laboratories",
    link: "Incubation Laboratories",
    arl: "l",
  },
  {
    id: "11",
    path: "/incubation/mou",
    link: "Industry Relation MoUs",
    arl: "l",
  },
  {
    id: "5",
    path: "/incubation/incubation_facilities",
    link: "Operating Units",
    arl: "l",
  },

  {
    id: "12",
    path: "https://forms.gle/zrWRqRoSr2D7Pqp98",
    link: "Application",
    arl: "l",
  },
  {
    id: "13",
    path: "/incubation/event_gallery",
    link: "Event Gallery",
    arl: "l",
  },
  {
    id: "13",
    path: "/incubation/onboarding_companies",
    link: "Onboarding Companies",
    arl: "l",
  }
];

const operating_system_menu = [
  {
    id: "1",
    path: "/incubation",
    link: "About",
    arl: "l",
  },
  {
    id: "7",
    path: "/incubation/incubation_facilities#facility-1",
    link: "Startup Incubation",
    arl: "l",
  }, {
    id: "8",
    path: "/incubation/incubation_facilities#facility-2",
    link: "Research Commercialisation",
    arl: "l",
  },
  {
    id: "9",
    path: "/incubation/incubation_facilities#facility-3",
    link: "Co-working Space",
    arl: "l",
  },
  {
    id: "10",
    path: "/incubation/incubation_facilities#facility-4",
    link: "Industry R&D Centres",
    arl: "l",
  },
]

const focus_sectors = [
  {
    id: "1",
    point: "FinTech",
  },
  {
    id: "2",
    point: "B2B SaaS",
  },
  {
    id: "3",
    point: "HealthTech",
  },
  {
    id: "4",
    point: "CleanTech & Energy",
  },
  {
    id: "5",
    point: "EV Components",
  },
  {
    id: "6",
    point: "Deep Tech",
  },
  {
    id: "7",
    point: "Innovative and Sustainable Building Materials",
  },
  {
    id: "8",
    point: "Agri Tech",
  },
];

const focus_sector_mentors = [
  {
    sno: "1",
    focus: "B2B SaaS",
    mentor: "Mr. Vijay Krishna,Chakara Universal Tech labs Pvt Ltd,35/31,Chithiragupta nagar,Urapakkam,Chengalpatu,Kanchipuram-603210.Tamilnadu, & M/s Survey Sparrow, 4thJyothirmaya, Infopark Phase 2, Kakkanad,Kerala -682303.",
  },
  {
    sno: "2",
    focus: "Health tech",
    mentor: "Mr. Manigandan MaGa Tech Gramam Pvt Ltd,59/2M,Ayyarkadu,Erumaipatti,Eduppadi Salem 637102.&M/s Survey Sparrow, 4thJyothirmaya, Infopark Phase 2,Kakkanad, Kerala -682303.",
  },
  {
    sno: "3",
    focus: "Fintech",
    mentor: "M/s Bucksbox 22 Valayar West Street, Near Church, Kottaiyur ,Karaikudi, TamilNadu.",
  },
  {
    sno: "4",
    focus: "EV components",
    mentor: "M/s Qmax Test Equipments Pvt Ltd 6,Elcot Avenue ,IT Highway ,Sholinganallur,Chennai-600119 & Dr. Vijaya Rajeswaran Managing DirectorVi Microsystems Pvt Ltd.No:75 , Electronics Estate, Perungudi, Chennai-96",
  },
  {
    sno: "5",
    focus: "Deep Tech",
    mentor: "Dr. Vijaya Rajeswaran Managing DirectorVi Microsystems Pvt Ltd.No:75 , Electronics Estate, Perungudi, Chennai-96 & M/s Tarcin robotics,176,E 6th  street ,KK nagar,Madurai,TN-625020.  ",
  },
  {
    sno: "6",
    focus: "CleanTech & Energy",
    mentor: "Garuda Aerospace Pvt Lt 24/46,KB Dhasan road,Seethamal Colony,Lubthi colony,Alwarpet Chennai,TN-600018 & M/s Gandhigram rural instituteGandhigram, Dindigul district TN 624302."
  },
  {
    sno: "7",
    focus: "Agri Tech",
    mentor: "Garuda Aerospace Pvt Lt 24/46,KB Dhasan road, Seethamal Colony,Lubthi colony,Alwarpet ,Chennai,TN-600018 & M/s Gandhigram rural institute Gandhigram,Dindigul district TN 624302."
  },
  {
    sno: "8",
    focus: "Innovative and Sustainable Building Materials",
    mentor: "Mr. Vengadesan M/S Almino Structural Consultancy Pvt Ltd,N010/3087,60,Meenakshi nagar First street,near kings palacemahal,Pattinamkathan,Ramanathapuram, TN,623503."
  },
  {
    sno: "9",
    focus: "EDII, Innovative Voucher Product scheme",
    mentor: "Mr. J.Arumai Rooban, District Manager, EDII, Sivaganga"
  },
  {
    sno: "10",
    focus: "Business Incubator",
    mentor: "Business Incubator Mr. Vinoth Malaikani, CEO,EDII,ABIRF,Trichy"
  },
  {
    sno: "11",
    focus: "Startup TN schemes",
    mentor: "Mr. K.Sakthivel,Project lead,Startup Tn, Madurai."
  }
]
const startup_support_services = [
  {
    id: "1",
    point: "Company registration and filing",
  },
  {
    id: "2",
    point: "Accounting services",
  },
  {
    id: "3",
    point: "HR services",
  },
  {
    id: "4",
    point: "Legal",
  },
  {
    id: "5",
    point: "Intellectual property (Copyright, Trademarks, Patent filings)",
  },
  {
    id: "6",
    point: "Training and workshops",
  },
  {
    id: "7",
    point: "Seed funding support",
  },
  {
    id: "8",
    point: "Government agency funding",
  },
  {
    id: "9",
    point: "Networking and linkages with ACGCET alumni for Mentorship, Funding, Technical expertise and Market access",
  },
  {
    id: "10",
    point: "Venture capitalist/Angels/Investors introduction",
  },
  {
    id: "11",
    point: "Meeting with visitors of ACGCET (such as Alumni, Industry professionals)",
  },
  {
    id: "12",
    point: "Showcasing AIF incubated companies through networking and events",
  },
  {
    id: "13",
    point: "Monthly entrepreneurship meets",
  },
];

// const facilities_available = [
//   {
//     id: 1,
//     title: "Start-up Incubation ",
//     description: {
//       heading: "Overview",
//       text: `This vertical focuses on supporting early-stage start-ups working in science, technology, and engineering domains. The incubator provides them with workspace, mentoring, fundraising access, and business support services.`
//     },
//     link: {
//       heading: "SOP for Start-up Incubation",
//       url: "  https://docs.google.com/document/d/1LKbAKEDbW22LIA4J9dW79BysCmcTnRIf/edit ",
//     },
//   },
//   {
//     id: 2,
//     title: "Industry R&D Centres ",
//     description: {
//       heading: "Overview",
//       text: `The incubator also supports industry-institution collaborations by enabling external companies to set up R&D units within the campus. These centres aim to foster joint research, student exposure, faculty engagement, and tech transfer opportunities.`
//     },
//     link: {
//       heading: "SOP for Industry R&D Tie-ups",
//       url: "https://docs.google.com/document/d/1dJrVcpAy_2eyRzCqFw3YN2Smju4dhZgG4wdG822fyYg/edit ",
//     },
//   },
//   {
//     id: 3,
//     title: "Research Commercialisation ",
//     description: {
//       heading: "Overview",
//       text: `The Tech Park also facilitates external access to the Institution’s technical infrastructure — including high-end equipment, laboratories, and testing facilities — for research, experimentation, and data acquisition purposes. This will be operated as a fee-for-service basis, subject to institutional guidelines and availability.
//              The goal is to promote research commercialisation, generate institutional revenue, and enhance industry-academia engagement by unlocking the value of underutilised technical assets.`
//     },
//     link: {
//       heading: "SOP for Technical Infrastructure Access",
//       url: "https://docs.google.com/document/d/1TWxi-zSh71BxfYF5a9ZwbqsGhAEh-MApLgq9xU9YnTY/edit ",
//     },
//   },
//   {
//     id: 4,
//     title: "Co-working Space",
//     description: {
//       heading: "Overview",
//       text: `To promote a thriving local tech ecosystem, the incubator manages a co-working program for individual professionals, freelancers, and remote tech workers in the region. While not eligible for incubation benefits, these individuals are offered a structured work environment and access to basic resources.
// `
//     },
//     link: {
//       heading: "SOP for Co-working Program",
//       url: "https://docs.google.com/document/d/1W6GG41eYHadvzS4HqVv59uYgHaGuZgR_Q9FLnD2NCXQ/edit ",
//     },
//   },
// ];

const facilities_available = [
  {
    id: 1,
    title: "Start-up Incubation",
    image: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_5.webp",
    description: {
      heading: "Overview",
      text: `This vertical focuses on supporting early-stage start-ups working in science, technology, and engineering domains. The incubator provides them with workspace, mentoring, fundraising access, and business support services.`,
    },
    // pdf: {
    //   heading: "SOP for Start-up Incubation",
    //   url: "/Incubator SOP.pdf",
    // },
  },
  {
    id: 2,
    title: "Research Commercialisation",
    image: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/ResearchCommercialisation.webp",
    description: {
      heading: "Overview",
      text: `The Tech Park also facilitates external access to the Institution’s technical infrastructure — including high-end equipment, laboratories, and testing facilities — for research, experimentation, and data acquisition purposes. This will be operated as a fee-for-service basis, subject to institutional guidelines and availability.
The goal is to promote research commercialisation, generate institutional revenue, and enhance industry-academia engagement by unlocking the value of underutilised technical assets.`,
    },
    pdf: {
      heading: "SOP for Technical Infrastructure Access",
      url: "/Research_Commercialisation_SOP.pdf",
    },
  },
  {
    id: 3,
    title: "Co-working Space",
    image: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_5.webp",
    description: {
      heading: "Overview",
      text: `To promote a thriving local tech ecosystem, the incubator manages a co-working program for individual professionals, freelancers, and remote tech workers in the region. While not eligible for incubation benefits, these individuals are offered a structured work environment and access to basic resources.`,
    },
    pdf: {
      heading: "SOP for Co-working Program",
      url: "/Co-working_SOP.pdf",
    },
  },
  {
    id: 4,
    title: "Industry R&D Centres",
    image: "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/RnD+centers.webp",
    description: {
      heading: "Overview",
      text: `The incubator also supports industry-institution collaborations by enabling external companies to set up R&D units within the campus. These centres aim to foster joint research, student exposure, faculty engagement, and tech transfer opportunities.`,
    },
    pdf: {
      heading: "SOP for Industry R&D Tie-ups",
      url: "/R&D_Centres_SOP.pdf",
    },
  },
];

const incubationFaculty = [
  {
    "sno": "1",
    "faculty": "Dr.C.Subramanian, Professor",
    "Department": "Civil",
  },
  {
    "sno": "2",
    "faculty": "Dr SR Sumathy, Associate Professor ",
    "Department": "Civil",
  },
  {
    "sno": "3",
    "faculty": "Dr. R. PRAKASH, Associate Professor",
    "Department": "Civil",
  },
  {
    "sno": "4",
    "faculty": "Dr.C.Vijayaprabha, Associate Professor",
    "Department": "Civil",
  },
  {
    "sno": "5",
    "faculty": "Dr.S.M.Kavitha, Associate Professor",
    "Department": "Civil",
  },
  {
    "sno": "6",
    "faculty": "Dr.V.Jayanthi, Associate Professor",
    "Department": "Civil",
  },
  {
    "sno": "7",
    "faculty": "Dr.A.Leelavathi, Assistant Professor",
    "Department": "Civil",
  },
  {
    "sno": "8",
    "faculty": "Venkatesh B, Assistant Professor",
    "Department": "Civil",
  },
  {
    "sno": "8",
    "faculty": "Venkatesh B, Assistant Professor",
    "Department": "Civil"
  },
  {
    "sno": "9",
    "faculty": "Dr.K.Ramanathan, Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "10",
    "faculty": "Dr.S.Sankarapandian, Associate Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "11",
    "faculty": "Dr.A.Athijayamani, Associate Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "12",
    "faculty": "Dr.S.Geetha, Associate Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "13",
    "faculty": "Dr.R.Sarala, Associate Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "14",
    "faculty": "Dr.S.M.Sivagami, Associate Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "15",
    "faculty": "Prof.S.Selvaraj, Assistant Professor(Sr.Gr)",
    "Department": "Mechanical"
  },
  {
    "sno": "16",
    "faculty": "Prof.V.Jawahar, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "17",
    "faculty": "Prof.S.Senthilkumar, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "18",
    "faculty": "Prof.P.Perumal, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "19",
    "faculty": "Prof.T.Rajavijay, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "20",
    "faculty": "Dr.P.Raveendiran, Associate Professor(CAS)",
    "Department": "Mechanical"
  },
  {
    "sno": "21",
    "faculty": "Dr.J.Prabakaran, Associate Professor(CAS)",
    "Department": "Mechanical"
  },
  {
    "sno": "22",
    "faculty": "Dr.C.R.Senthilkumar, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "23",
    "faculty": "Dr.B.Guruprasad, Assistant Professor(Sl.Gr)",
    "Department": "Mechanical"
  },
  {
    "sno": "24",
    "faculty": "Dr.N.Babu, Assistant Professor",
    "Department": "Mechanical"
  },
  {
    "sno": "25",
    "faculty": "Dr.K.Baskaran, Professor",
    "Department": "EEE"
  },
  {
    "sno": "26",
    "faculty": "Dr.A.ArunyaRevathi, Professor (CAS)",
    "Department": "EEE"
  },
  {
    "sno": "27",
    "faculty": "Dr.S.Nageswari, Associate Professor",
    "Department": "EEE"
  },
  {
    "sno": "28",
    "faculty": "Dr.C.Vennila, Associate Professor",
    "Department": "EEE"
  },
  {
    "sno": "29",
    "faculty": "Dr.S.Venkatesan, Associate Professor",
    "Department": "EEE"
  },
  {
    "sno": "30",
    "faculty": "Prof.P.Madasamy, Associate Professor(CAS)",
    "Department": "EEE"
  },
  {
    "sno": "31",
    "faculty": "Prof.K.Ramadas, Associate Professor(CAS)",
    "Department": "EEE"
  },
  {
    "sno": "32",
    "faculty": "Dr.M.Arun, Associate Professor(CAS)",
    "Department": "EEE"
  },
  {
    "sno": "33",
    "faculty": "Prof.M.L.Ramamoorthy, Assistant Professor",
    "Department": "EEE"
  },
  {
    "sno": "34",
    "faculty": "Prof.V.Pradeep, Assistant Professor",
    "Department": "EEE"
  },
  {
    "sno": "35",
    "faculty": "Prof.K.Padmanaban, Assistant Professor",
    "Department": "EEE"
  },
  {
    "sno": "36",
    "faculty": "Prof.S.Aasaimani, Assistant Professor",
    "Department": "EEE"
  },
  {
    "sno": "37",
    "faculty": "Dr.A.Sivanantha Raja, Professor",
    "Department": "ECE"
  },
  {
    "sno": "38",
    "faculty": "Dr.G.Karpagarajesh, Associate Professor",
    "Department": "ECE"
  },
  {
    "sno": "39",
    "faculty": "Dr.D.Helena Margaret, Associate Professor",
    "Department": "ECE"
  },
  {
    "sno": "40",
    "faculty": "Dr.C.Mahendran, Assistant Professor",
    "Department": "ECE"
  },
  {
    "sno": "41",
    "faculty": "Dr.S.Somasundaram, Associate Professor",
    "Department": "ECE"
  },
  {
    "sno": "42",
    "faculty": "Dr.C.Karthika Pragadeeswari, Assistant Professor",
    "Department": "ECE"
  },
  {
    "sno": "43",
    "faculty": "Dr.G.Dhevanandhini, Assistant Professor",
    "Department": "ECE"
  },
  {
    "sno": "44",
    "faculty": "Dr.B.Rajesh Kanna, Assistant Professor",
    "Department": "ECE"
  },
  {
    "sno": "45",
    "faculty": "Dr.C.UmaRani, Associate Professor",
    "Department": "CSE"
  },
  {
    "sno": "46",
    "faculty": "K.Chandraprabha, Associate Professor",
    "Department": "CSE"
  },
  {
    "sno": "47",
    "faculty": "S.Syed Suhaila, Assistant Professor",
    "Department": "CSE"
  },
  {
    "sno": "48",
    "faculty": "Dr.K.Sundara Krishnan, Assistant Professor",
    "Department": "CSE"
  },
  {
    "sno": "49",
    "faculty": "Dr.N.Hema Rajini, Associate Professor",
    "Department": "CSE"
  },
  {
    "sno": "50",
    "faculty": "Dr.S.Ponmudi, Associate Professor",
    "Department": "Physics"
  },
  {
    "sno": "51",
    "faculty": "Mr.S.Venkatrajan, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "52",
    "faculty": "Dr.S.R.Cynthia, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "53",
    "faculty": "Dr.G.Sivaganesh, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "54",
    "faculty": "Mr.R.Parthiban, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "55",
    "faculty": "Dr.K.R.Vijayaraghavan, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "56",
    "faculty": "Dr.R.N.Mariammal, Assistant Professor",
    "Department": "Physics"
  },
  {
    "sno": "57",
    "faculty": "Dr.K.T.Loganathan, Assistant Professor",
    "Department": "Chemistry"
  },
  {
    "sno": "58",
    "faculty": "Dr.M.Thenraj, Assistant Professor",
    "Department": "Chemistry"
  },
  {
    "sno": "59",
    "faculty": "M.Rajaperumal, Assistant Professor",
    "Department": "Chemistry"
  }
];


const Startup_Incubation = [
  {
    id: 1,
    title: "Start-up Incubation ",
    description: {
      heading: "Overview",
      text: `This vertical focuses on supporting early-stage start-ups working in science, technology, and engineering domains. The incubator provides them with workspace, mentoring, fundraising access, and business support services.`
    },
    link: {
      heading: "SOP for Start-up Incubation",
      url: "  https://docs.google.com/document/d/1LKbAKEDbW22LIA4J9dW79BysCmcTnRIf/edit ",
    },
  },
]


const Industry_RnD_Centres = [{
  id: 2,
  title: "Industry R&D Centres ",
  description: {
    heading: "Overview",
    text: `The incubator also supports industry-institution collaborations by enabling external companies to set up R&D units within the campus. These centres aim to foster joint research, student exposure, faculty engagement, and tech transfer opportunities.`
  },
  link: {
    heading: "SOP for Industry R&D Tie-ups",
    url: "https://docs.google.com/document/d/1dJrVcpAy_2eyRzCqFw3YN2Smju4dhZgG4wdG822fyYg/edit ",
  },
},
]

const Research_Commercialisation = [{
  id: 3,
  title: "Research Commercialisation ",
  description: {
    heading: "Overview",
    text: `The Tech Park also facilitates external access to the Institution’s technical infrastructure — including high-end equipment, laboratories, and testing facilities — for research, experimentation, and data acquisition purposes. This will be operated as a fee-for-service basis, subject to institutional guidelines and availability.
             The goal is to promote research commercialisation, generate institutional revenue, and enhance industry-academia engagement by unlocking the value of underutilised technical assets.`
  },
  link: {
    heading: "SOP for Technical Infrastructure Access",
    url: "https://docs.google.com/document/d/1TWxi-zSh71BxfYF5a9ZwbqsGhAEh-MApLgq9xU9YnTY/edit ",
  },
},
]

const Co_Working_Space = [{
  id: 4,
  title: "Co-working Space",
  description: {
    heading: "Overview",
    text: `To promote a thriving local tech ecosystem, the incubator manages a co-working program for individual professionals, freelancers, and remote tech workers in the region. While not eligible for incubation benefits, these individuals are offered a structured work environment and access to basic resources.
`
  },
  link: {
    heading: "SOP for Co-working Program",
    url: "https://docs.google.com/document/d/1W6GG41eYHadvzS4HqVv59uYgHaGuZgR_Q9FLnD2NCXQ/edit ",
  },
},
]











const Incubation_mous =
  [
    {
      "s.no": "1",
      "companyName": "Bucks Box Software Pvt Ltd",
      "FocusSector": "FinTech",
      "ServiceProvided": `🡪Training,Research,Design&development,Consultancy 
                                🡪In Financial Software for UG & PG students
                                🡪Joint projects for Student`
    },

    {
      "s.no": "2",
      "companyName": "Chakra Universal Tech Labs Pvt Ltd",
      "FocusSector": "B2B, SaaS, Cloud platform",
      "ServiceProvided":
        `🡪Full time employment
      🡪Internship
      🡪Training
      🡪Project
      🡪Max of 15-20 Students`

    },
    {
      "s.no": "3",
      "companyName": "MAGA Tech Gramam Pvt Ltd",
      "FocusSector": "Healthcare, Manufacturing, Energy, Banking sector",
      "ServiceProvided": [
        ` 🡪Full time employment
      🡪Internship
      🡪Training
      🡪Project
      🡪Max of 15-20 Students
      🡪Project mentorship
      🡪Workshops
      🡪Seminars/Webinars
      🡪Professional development`
      ]
    },
    {
      "s.no": "4",
      "companyName": "Infosys Ltd",
      "FocusSector": "Deep Tech",
      "ServiceProvided": [
        `🡪Java
      🡪Python
      🡪C++
      🡪JavaScript
      🡪via online`
      ]
    },
    {
      "s.no": "5",
      "companyName": "K.R.Alagappan",
      "FocusSector": "Innovation & Sustainable building materials",
      "ServiceProvided": [
        `🡪Provides training platform for innovative projects on Bricks`
      ]
    },
    {
      "s.no": "6",
      "companyName": "Garuda Aerospace Pvt Ltd",
      "FocusSector": "Drone technology",
      "ServiceProvided": [
        `🡪R&D
      🡪Training
      🡪Service & Maintenance
      🡪Advisory role in academics
      🡪Internship & Platform
      🡪RPTO licensed training to students and faculty
      🡪Theory & simulation training`
      ]
    },
    {
      "s.no": "7",
      "companyName": "Irrigation Management Training Institute (IMTI)",
      "FocusSector": "Clean tech",
      "ServiceProvided": [
        `🡪Students get internship
      🡪Workshops/Lectures by IMTI
      🡪Students can access their library, software, lab equipment and workshop (cost only for consumables and labour)`
      ]
    },
    {
      "s.no": "8",
      "companyName": "Qmax Test Technologies Pvt Ltd",
      "FocusSector": "Electronic test engineering",
      "ServiceProvided": [
        `🡪Guest lecture
      🡪Industrial training and visits
      🡪Placement of trained students`
      ]
    },
    {
      "s.no": "9",
      "companyName": "Survey Sparrow Pvt Ltd",
      "FocusSector": "Software development, Tech support service",
      "ServiceProvided": [
        `🡪Industrial Visit (IV)
      🡪Internship
      🡪Projects
      🡪Guest lecture`
      ]
    },
    {
      "s.no": "10",
      "companyName": "Tarcin Robotics LLP",
      "FocusSector": "Robotics",
      "ServiceProvided": [
        `🡪Microsoft Azure
      🡪AWS
      🡪GCP
      🡪Artificial Intelligence
      🡪Machine Learning
      🡪Using Python
      🡪Machine Learning using Studio
      🡪Students project & Internship`
      ]
    },
    {
      "s.no": "11",
      "companyName": "Bluestar Foundation",
      "FocusSector": "Scholarship for Mechanical, Electrical, IT and Electronics students",
      "ServiceProvided": [
        `🡪Financial aid
      🡪Mentoring
      🡪Internship
      🡪Soft skill training
      🡪Eligibility: CGPA ≥ 7.5, 80% in HSC, family income <10 LPA (for 1st & 2nd year EEE, Mech, IT & Electronics)`
      ]
    },
    {
      "s.no": "12",
      "companyName": "iTNT",
      "FocusSector": "Deep Tech",
      "ServiceProvided": [
        `🡪Incubation service for early-stage Deep Tech startups
      🡪To build Innovation network
      🡪Innovation workshop
      🡪Innovation Network program activity
      🡪Research project
      🡪Training progress
      🡪Entrepreneur initiative`
      ]
    },
    {
      "s.no": "13",
      "companyName": "Gandhigram Rural Institute",
      "FocusSector": "Rural & Agricultural Development",
      "ServiceProvided": [
        `🡪Rural energy
      🡪Agricultural value chain
      🡪Agri business
      🡪Rural craft and Artisans development
      🡪Rural Industrial & Entrepreneurship
      🡪Rural health, Sanitation, Solid Waste Management
      🡪Liquid Waste Management
      🡪Rural Infrastructure
      🡪Water resource management
      🡪Sustainable Agriculture
      🡪Implementation of various Government schemes
      🡪Skill development, Startups and Digital Know-How
      🡪Climate change
      🡪SDG
      🡪Academic programme support
      🡪Development & Execution of projects: Rural, Tribal, Farming opportunities
      🡪Organize training programs, seminars, workshops
      🡪Promoting research — Unnat Bharat Abhiyan"`
      ]
    },
    {
      "s.no": "14",
      "companyName": "Skillsort Technical Solutions Pvt Ltd",
      "FocusSector": "Skill Development",
      "ServiceProvided": [
        `🡪Free enrolment for eligible Final year students
      🡪Providing 3 Online MCQ Tests for each Aptitude & Technical Skill`
      ]
    }
  ]






const three_d_printer = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/3D+PRINTER.webp";
const accelerated_curing_tank = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/ACCELERATED+CURING+TANK.webp";
const antenna_chamber = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/ANTENNA+CHAMBER.webp";
const atomic_absorption = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/ATOMIC+ABSORPTION.webp";
const brick_die = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/BRICK+DIE.webp";
const double_disc_polisher = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/DOUBLE+DISC+POLISHER.webp";
const ev_lab = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/EV+LAB.webp";
const fly_ash_brick_unit = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/FLY+ASH+BRICK+UNIT.webp";
const hollow_block_die = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/HOLLOW+BLOCK+DIE.webp";
const hollow_block_machine = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/HOLLOW+BLOCK+MACHINE.webp";
const jetson_nano = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/JestonNano.webp";
const laminar_inflow_chamber = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/LAMINAR+INFLOCHAMBER.webp";
const laser_interferometer_2 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/LASER+INTERFEROMETER_2.webp";
const laser_interferometer = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/LASER+INTERFEROMETER.webp";
const loading_frame_1000kn = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/LOADING+FRAME+1000KN.webp";
const loading_frame_500kn = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/LOADING+FRAME+500KN.webp";
const microscope = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/MICROSCOPE.webp";
const mig_welding_machine = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/MIG+welding+machine.webp";
const modern_electric_drive = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/MODERN+ELECTRIC+DRIVE.webp";
const pile_testing = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/PILE+TESTING.webp";
const power_quality_analyser = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/POWER+QUALITY+ANALYSER.webp";
const rcpt_apparatus = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/RCPT++APPARATUS.webp";
const screwdriven_utm = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/SCREWDRIVEN+UTM.webp";
const sem_with_edax = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/SEM+WITH+EDAX.webp";
const servo_hydraulic_utm_250 = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/SERVO+HYDRAULIC+UTM+250.webp";
const shake_table = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/SHAKE+TABLE.webp";
const smart_drive = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/SMART+DRIVE.webp";
const thin_film_deposition_setup = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/THIN+FILM+DEPOSITION+SETUP.webp";
const total_station = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/TOTAL+STATION.webp";
const welding_simulator = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/WELDING+SIMULATOR.webp";
const xray_diffractometer = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/incubation_laboratories/XRAY+DIFFRACTOMETER.webp";
// To add 
const Microprocessor = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Mechatronics_lab.webp"
const Mobilerobot = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Eyantra.webp"
const solarWater = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Solar_Power_lab.webp"
const millingMachine = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/MT_II.webp"
const YASKAWA_Motoman = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Centre_of_Excellence.webp"
const cutsection = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/K_M_lab.webp"
const lathemachine = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/MT_I.webp"
const steamPowerPlant = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Fuels_lab.webp"
const deiselEngineRig = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Thermal_lab.webp"
const heatExchanger = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Heat_Transfer_lab.webp"
const DCMotoLoad = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Mech/Lab_facilities/Dynamics_Machinery_lab.webp"


const incubation_laboratories = [
  {
    id: "1",
    heading: "3D PRINTER",
    "sub-head": "",
    pic: three_d_printer,
  },
  {
    id: "2",
    heading: "ACCELERATED CURING TANK",
    "sub-head": "",
    pic: accelerated_curing_tank,
  },
  {
    id: "3",
    heading: "ANTENNA CHAMBER",
    "sub-head": "",
    pic: antenna_chamber,
  },
  {
    id: "4",
    heading: "ATOMIC ABSORPTION",
    "sub-head": "",
    pic: atomic_absorption,
  },
  {
    id: "5",
    heading: "BRICK DIE",
    "sub-head": "",
    pic: brick_die,
  },
  {
    id: "6",
    heading: "DOUBLE DISC POLISHER",
    "sub-head": "",
    pic: double_disc_polisher,
  },
  {
    id: "7",
    heading: "EV LAB",
    "sub-head": "",
    pic: ev_lab,
  },
  {
    id: "8",
    heading: "FLY ASH BRICK UNIT",
    "sub-head": "",
    pic: fly_ash_brick_unit,
  },
  {
    id: "9",
    heading: "HOLLOW BLOCK DIE",
    "sub-head": "",
    pic: hollow_block_die,
  },
  {
    id: "10",
    heading: "HOLLOW BLOCK MACHINE",
    "sub-head": "",
    pic: hollow_block_machine,
  },
  {
    id: "11",
    heading: "JETSON NANO",
    "sub-head": "",
    pic: jetson_nano,
  },
  {
    id: "12",
    heading: "LAMINAR INFLOW CHAMBER",
    "sub-head": "",
    pic: laminar_inflow_chamber,
  },
  {
    id: "13",
    heading: "LASER INTERFEROMETER 2",
    "sub-head": "",
    pic: laser_interferometer_2,
  },
  {
    id: "14",
    heading: "LASER INTERFEROMETER",
    "sub-head": "",
    pic: laser_interferometer,
  },
  {
    id: "15",
    heading: "LOADING FRAME 1000KN",
    "sub-head": "",
    pic: loading_frame_1000kn,
  },
  {
    id: "16",
    heading: "LOADING FRAME 500KN",
    "sub-head": "",
    pic: loading_frame_500kn,
  },
  {
    id: "17",
    heading: "MICROSCOPE",
    "sub-head": "",
    pic: microscope,
  },
  {
    id: "18",
    heading: "MIG WELDING MACHINE",
    "sub-head": "",
    pic: mig_welding_machine,
  },
  {
    id: "19",
    heading: "MODERN ELECTRIC DRIVE",
    "sub-head": "",
    pic: modern_electric_drive,
  },
  {
    id: "20",
    heading: "PILE TESTING",
    "sub-head": "",
    pic: pile_testing,
  },
  {
    id: "21",
    heading: "POWER QUALITY ANALYSER",
    "sub-head": "",
    pic: power_quality_analyser,
  },
  {
    id: "22",
    heading: "RCPT APPARATUS",
    "sub-head": "",
    pic: rcpt_apparatus,
  },
  {
    id: "23",
    heading: "SCREWDRIVEN UTM",
    "sub-head": "",
    pic: screwdriven_utm,
  },
  {
    id: "24",
    heading: "SEM WITH EDAX",
    "sub-head": "",
    pic: sem_with_edax,
  },
  {
    id: "25",
    heading: "SERVO HYDRAULIC UTM 250",
    "sub-head": "",
    pic: servo_hydraulic_utm_250,
  },
  {
    id: "26",
    heading: "SHAKE TABLE",
    "sub-head": "",
    pic: shake_table,
  },
  {
    id: "27",
    heading: "SMART DRIVE",
    "sub-head": "",
    pic: smart_drive,
  },
  {
    id: "28",
    heading: "THIN FILM DEPOSITION SETUP",
    "sub-head": "",
    pic: thin_film_deposition_setup,
  },
  {
    id: "29",
    heading: "TOTAL STATION",
    "sub-head": "",
    pic: total_station,
  },
  {
    id: "30",
    heading: "WELDING SIMULATOR",
    "sub-head": "",
    pic: welding_simulator,
  },
  {
    id: "31",
    heading: "XRAY DIFFRACTOMETER",
    "sub-head": "",
    pic: xray_diffractometer,
  },
  {
    id: "32",
    heading: "MICROPROCESSOR & MICROCONTROLLER LAB",
    "sub-head": "",
    pic: Microprocessor,
  },
  {
    id: "33",
    heading: "Mobile Robot (Autonomous Robot /Educational Robot Kit)",
    "sub-head": "",
    pic: Mobilerobot,
  },
  {
    id: "34",
    heading: "SOLAR WATER HEATER LAB",
    "sub-head": "",
    pic: solarWater,
  },
  {
    id: "35",
    heading: "MILLING MACHINE",
    "sub-head": "",
    pic: millingMachine,
  },
  {
    id: "36",
    heading: "Industrial Robot Arm – YASKAWA Motoman",
    "sub-head": "",
    pic: YASKAWA_Motoman,
  },
  {
    id: "37",
    heading: "Cut section model of a gearbox",
    "sub-head": "",
    pic: cutsection,
  },
  {
    id: "38",
    heading: "LATHE MACHINE",
    "sub-head": "",
    pic: lathemachine,
  },
  {
    id: "39",
    heading: "STEAM POWER PLANT LAB",
    "sub-head": "",
    pic: steamPowerPlant,
  },
  {
    id: "40",
    heading: "Diesel Engine Test Rig ",
    "sub-head": "",
    pic: deiselEngineRig,
  },
  {
    id: "41",
    heading: "Parallel Flow counter Flow heat exchanger",
    "sub-head": "",
    pic: heatExchanger,
  },
  {
    id: "42",
    heading: "DC Motor Load Test Setup",
    "sub-head": "",
    pic: DCMotoLoad,
  },
];


const incubation_img_corousal =
{
  id: 1,
  title: "Alagappa Incubation Forum",
  img_list: [img6, img1, img2, img3, img4, img5],
}


const event_gallery_content = [
  {
    id: "1",
    heading: "Glimpse of the First Event by AIF",
    // date: "17.07.2025",
    // organizer: "Alagappa Incubation Forum, ACGCET",
    content:
      "A Knowledge Sharing Session on “Innovation and Startup Ecosystem” was organized by the Alagappa Incubation Forum, ACGCET, on 17.07.2025. The session, led by Mr. K. Sakthivel, Project Lead, StartupTN (Madurai Hub), inspired students and faculty to embrace entrepreneurship and innovation, fostering a strong startup mindset across the campus.",
    images: [
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIRST_EVENT_1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIRST_EVENT_2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIRST_EVENT_3.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIRST_EVENT_4.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIRST_EVENT_5.webp"
    ]
  },
  {
    id: "2",
    heading: "Glimpse of Outreach program by AIF",
    // date: "17.07.2025",
    // organizer: "Alagappa Incubation Forum, ACGCET",
    content:
      "Alagappa Incubation Forum (AIF), ACGCET, Karaikudi, organized an outreach program on “Innovation and Startups” for students and faculty from Annamalai Polytechnic College. Mr. M. Shankar Ganesh, Manager – AIF, shared valuable insights on entrepreneurship, innovation, and startup opportunities. He emphasized the role of startups in economic growth and encouraged students to engage with the entrepreneurial ecosystem. The session also highlighted funding support and initiatives provided by StartupTN.",
    images: [
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FOURTH_EVENT_1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FOURTH_EVENT_2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FOURTH_EVENT_3.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FOURTH_EVENT_4.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FOURTH_EVENT_5.webp"
    ]
  },
  {
    id: "3",
    heading: "Glimpse of pitching session",
    // date: "10.09.2025",
    // organizer: "Alagappa Incubation Forum, ACGCET",
    content:
      "A Pitching Session was conducted on 10th September 2025 at the AIF Office, where incubatees presented the flow of their innovative ideas and projects. This session provided an interactive platform for students and mentors to understand the concept, technical approach, and expected impact of each innovation.\nThe incubatees presented:\n1. EV Charging Point – by Mr. Tamimun Ansari S\n2. Demand Control in a Distribution System – by Mr. Rajendran\n3. Body Leakage Current Breaker – by Mr. Saravanan.",
    images: [
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIFTH_EVENT_1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIFTH_EVENT_2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIFTH_EVENT_3.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/FIFTH_EVENT_4.webp",
    ]
  },
  {
    id: "4",
    heading: "Glimpse of Alagappa Incubation Forum MoU With Industries",
    images: [
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/03+Bucksbox.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/06+Dhasara.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/05+Magatech.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/02+Vi+Microsystem.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/01+Hexwave.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/04+Chakra.webp",
    ]
  },
  {
    id: "5",
    heading: "Glimpse of Karaikudi Startup Meetup ",
    content:
      `Proud to say, first among government colleges to host an Incubation forum in the name of Vallal Alagappa chettiar upholding the legacy of his charity with sole vision to create an eco-system for start-ups to thrive in Karaikudi region. This incubation forum is backed by StartupTN initiative.

The first of its kind gathering in Karaikudi aiming to boost the start-up ecosystem in Karaikudi and its surroundings, People who are already a start-up and start-up aspirants including students took part in this meetup with sheer enthusiasm. The meetup attracted overwhelming registrations of 184 persons in which 100 people actively participated in the meet-up.

The meeting presided over by Dr. K. Baskaran (Principal – ACGCET/Director- Alagappa Incubation Forum) & welcome address given by Dr. A. Sivanantha Raja (Controller of Examinations/HoD of ECE Dept.) followed by an introductory talk by Dr. S. M. Kavitha (Coordinator - Alagappa Incubation Forum/Associate professor of Civil Dept.) then presentation given on the facilities available at the forum by Mr. M. Shankar Ganesh (Incubation manager – Alagappa Incubation Forum) later on Mr. K. Sakthivel (Project lead - StartupTN) spoke about the various schemes and fundings provided by the Tamilnadu government via StartupTN.

As an incubatee, Mr. Vijay Krishna (Founder/CEO – Chakraa Universal Tech Labs Pvt Ltd) represented his company’s overall experience with the forum. Officials from Indian Overseas Bank, Karaikudi created awareness among the startup enthusiasts on the loan facilities that can be availed from them.

The meeting’s primary focus is to create awareness on schemes and facilities of the Incubation forum. As an impact of the meetup, 14 start-up enthusiasts shown deep interest to incubate themselves in the forum. The forum has already on-boarded 5 companies and already operating in full-swing, these companies’ sectors span across EV, Deep-tech, SaaS, Fintech & Health-care.

Three companies are in the process to on-board. Ambitious students who participated in ‘Thiran’ hackathon are encouraged to scale their ideas into start-ups, in which 3 of student-teams are in process to receive funding from the government.

The Incubation forum also encourages students from school-level to take part in the start-up environment. As a result, 11th std students from Government Higher Secondary School, Ariyakudi registered their innovation on Space-tech with us and applied for Innovation Voucher Product funding from TN Government through StartupTN initiative.

The journey of Alagappa Incubation Forum has just begun and yet to witness remarkable achievements and growth of start-ups in Karaikudi region. We believe that the incubation forum will be instrumental to support and make start-ups to thrive in the ecosystem in Karaikudi region.`,

    images: [
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation3.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation4.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation5.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/incubation6.webp",
    ]
  },
  {
    id:"6",
    heading:"Glimpse of Gramam Thorum Puthozhil",
    content:`Gramam Thorum Puthozhil Scheme, a flagship initiative by StartupTN in collaboration with Alagappa Incubation Forum (AIF), aims to build a village-level startup ecosystem through grassroots innovation.As part of this initiative, Kundrakudi village is promoting “Kundrakudi Red Oxide Primer”, developed from cashew nut waste, showcasing a strong waste-to-wealth and sustainable entrepreneurship model.The programme was launched on 13.01.2026 at the StartupTN Madurai Hub by Mr.Sivarajah Ramanathan, CEO & Mission Director, Startup-TN.`,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Gramam+Thorum+Puthozhil+pic1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Gramam+Thorum+Puthozhil+pic+2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Gramam+Thorum+Puthozhil+pic+3.webp"
    ]
  },
  {
    id:"7",
    heading:"Glimpse of Alagappa Incubation Forum MoU with Industries",
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Forum+MoU+with+Industries1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Forum+MoU+with+Industries2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Forum+MoU+with+Industries3.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Forum+MoU+with+Industries4.webp"
    ]
  },
  {
    id:"8",
    heading:"StartupTN Incubation Management Training Programme & Scaleup Grant Support ",
    content:`Alagappa Incubation Forum (AIF) participated in the StartupTN Incubation Management Training Programme 2025 held from 3rd to 5th December 2025 at Ooty. The programme focused on improving incubation management, startup ecosystem development, stakeholder engagement, and innovation practices. Mr. M. Shankar Ganesh represented AIF, successfully completed the training, and received a certificate from StartupTN and its international partners.

After the training and evaluation, AIF was selected as one of the top incubators in Tamil Nadu for the StartupTN Scaleup Grant and was sanctioned ₹5,00,000 to strengthen incubation infrastructure and operations. The sanction letter was issued by the Mission Director and CEO of StartupTN, and the grant certificate was formally handed over by the Honorable MSME Minister of Tamil Nadu.

This recognition highlights AIF’s growing role in promoting innovation, entrepreneurship, and startup development while continuing to support startups through mentoring, training, technical assistance, and incubation services.`,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/startup_TN_incubation+(1).webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Startup_TN_incubation2.webp",
    ]
  },
   {
    id:"9",
    heading:"Glimpse of Alagappa Incubation Forum AIF MoU signing with Industries",
    //content:` `,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/aif_mou.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/aif_mou1.webp",
    ]
  },
  {
    id:"10",
    heading:"Glimpse of Alagappa Incubation Forum Startup Show Case Summit on 20.04.2026",
    //content:` `,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Incubation+Forum+Startup+Show+Case.webp"
    ]
  },
  {
    id:"11",
    heading:"Glimpse of Alagappa Incubation Forum Sinthithu Sei on 16.04.2026",
    //content:` `,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Sinthithu+sei%2C.webp"
    ]
  },
  {
    id:"12",
    heading:"Glimpse of Alagappa Incubation Forum Investor Ready Pitch deck preparation session on 21.05.2026",
    content:`Investor Ready pitch deck preparation session conducted by Alagappa Incubation Forum and its Mentor Mr.Venkat Kumaresan.
     Startups  namely Bulldroid, Dhasara Powertech, Aiini, Aattral inex, Vigosat, Pdven herbals had attended the pitch decks
      correction from Mentor interms of Investors point of view. `,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/invester+pitch+deck+(1).webp"
    ]
  },
  {
    id:"13",
    heading:"Incubatee Pitch deck Presentation on 11.06.2026",
    content:`The startup teams Dman, H2Next, Swasam AI, and Zha Technologies, represented by students of Sri Sakthi Engineering College,
     showcased their business ideas and presented their pitch decks before the Screening Committee of the Alagappa Incubation Forum for review and potential incubation support.`,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/pitch+dec+1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/pitch+dec+3.webp",
     "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/pitch+dec+4.webp",
     "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/pitch+dec+5.webp",
     "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/pitch+dec+12.webp"
    ]
  },
  {
    id:"12",
    heading:"Glimpse of Alagappa Incubation Forum mou signing with Industries",
    content:` Aif mou with Industries:
Startups namely Dman,H2next,zha technologies,Swasam AI signed agreement with Alagappa Incubation Forum after they passed the screening and selection and are selected as Incubatees under Alagappa Incubation Forum.`,
    images:[
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Glimpse_2.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Glimpse_1.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Glimpse_4.webp",
      "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/event_gallery/Glimpse_3.webp"
      
    ]
  }
]

const onboarding_companies = [
  {
    sno: "1",
    company_name: "HexwaveTechnologies, Chennai",
    focus: "EV Charging Point",
  },
  {
    sno: "2",
    company_name: "Vi Microsystems Pvt Ltd, Chennai",
    focus: "Deep Tech",
  },
  {
    sno: "3",
    company_name: "Chakra Universal Tech Labs Pvt Ltd, Chennai",
    focus: "B2B and SaaS",
  },
  {
    sno: "4",
    company_name: "BucksBox Software Pvt Ltd, Karaikudi",
    focus: "Fintech",
  },
  {
    sno: "5",
    company_name: "Maga Tech Gramam Pvt Ltd, Salem",
    focus: "Healthtech",
  },
  {
    sno: "6",
    company_name: "Sri Dhasara Power Tech, Madurai",
    focus: "Energy Conservation System"
  },
  {
    sno: "7",
    company_name: "Bulldroid Agri Robotics Private limited,Kalayarkoil,Sivaganga",
    focus:"Agritech ",
  },
  {
    sno: "8",
    company_name: "Aiini,Karaikudi",
    focus:"Fintech",
  },
  {
    sno: "9",
    company_name: "Build home mart squares pvt limited,Madurai-",
    focus:"E com platform ",
  },
  {
    sno: "10",
    company_name: "Civilink pvt limited,Karaikudi",
    focus:"E com platform ",
  },
  {
    sno: "11",
    company_name: "Akims technologies pvt limited",
    focus:" IT services and Digital solutions ",
  },
  {
    sno: "12",
    company_name: "Roza Solutions,Karaikudi",
    focus:"Research and Product development  Company",
  },
  {
    sno: "13",
    company_name: "Zarq games",
    focus:"Educational video games",
  },
];

export {
  incubation_vision,
  incubation_mission,
  incubation_objectives,
  incubation_menu,
  focus_sectors,
  startup_support_services,
  facilities_available,
  incubationFaculty,
  board_members,
  core_team,
  focus_sector_mentors,
  onboarding_companies,
  incubation_laboratories,
  Incubation_mous,
  incubation_img_corousal,
  Startup_Incubation,
  Industry_RnD_Centres,
  Research_Commercialisation,
  Co_Working_Space,
  operating_system_menu,
  event_gallery_content
};
